import { createUI } from "./ui.js";
import { saveSteps, loadSteps } from "./storage.js";

let exportCallback = null; // Store user-provided callback

function startGuideOverlay(callback) {
  if (window.GuideOverlayLoaded) return;
  window.GuideOverlayLoaded = true;

  let steps = loadSteps();
  
  exportCallback = callback; // Store callback function

  function init() {
    createUI(steps, saveSteps);
    setupExportButton(exportCallback);
  }

  init();
}

function setupExportButton(exportCallback) {
  document.getElementById("export-guide").addEventListener("click", () => {
    let steps = loadSteps();

    if (exportCallback && typeof exportCallback === "function") {
      exportCallback(steps); 
    } else {
      console.log("Guide Steps:", JSON.stringify(steps, null, 2));
      alert("Check the console for exported guide steps!");
    }
  });
}

// Attach to `window` for CDN usage
if (typeof window !== "undefined") {
  window.startGuideOverlay = startGuideOverlay;
}

export { startGuideOverlay };
